/**
 * Factory for binding module extensions to context with consistent no-op defaults.
 * When extension is undefined, returns the defaults object. Otherwise returns the bound API.
 */
export function createExtensionBinder<TExt, TCtx, TApi>(
  defaults: TApi,
  bind: (extension: TExt, context: TCtx) => TApi
): (extension: TExt | undefined, context: TCtx) => TApi {
  return (extension, context) =>
    extension ? bind(extension, context) : defaults;
}
